import React from "react";
import { Zap, Truck, IndianRupee, ShieldCheck } from "lucide-react";

const STEPS = [
  { n: "01", Icon: Zap, title: "Get AI Price Quote", desc: "Answer 4 quick condition questions and receive an AI-verified spot valuation in 45 seconds." },
  { n: "02", Icon: Truck, title: "Schedule Free Pickup", desc: "Pick your preferred time slot. Our certified agent visits your doorstep across Mumbai / Navi Mumbai." },
  { n: "03", Icon: IndianRupee, title: "On-Spot Cash / UPI", desc: "Quick 3-minute diagnostic test. Instant cash or UPI transferred right in front of you." },
];

export default function TrustSection() {
  return (
    <section id="how-it-works" className="relative py-16 lg:py-20 bg-slate-950 text-slate-100 overflow-hidden">
      <div className="absolute inset-0 tv-grid-bg opacity-20" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <span className="tv-chip mb-4" style={{ background: "rgba(56, 189, 248, 0.12)", color: "#38BDF8", borderColor: "rgba(56, 189, 248, 0.3)" }}>
            <ShieldCheck className="w-3.5 h-3.5" /> How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
            Three steps to spot cash — no calls, no visits, no waiting.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {STEPS.map((s) => (
            <div key={s.n} className="rounded-2xl border border-slate-800 bg-slate-900/50 p-6 backdrop-blur">
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs font-mono uppercase tracking-widest text-slate-400">Step {s.n}</span>
                <div className="w-11 h-11 rounded-xl bg-primary/20 text-primary flex items-center justify-center">
                  <s.Icon className="w-5 h-5" />
                </div>
              </div>
              <div className="text-xl font-semibold">{s.title}</div>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid sm:grid-cols-4 gap-4">
          {[
            { k: "12,400+", l: "Phones Bought" },
            { k: "₹18 Cr", l: "Cash Paid Out" },
            { k: "4.9/5", l: "Customer Rating" },
            { k: "45 sec", l: "Avg Quote Time" },
          ].map((s, i) => (
            <div key={i} className="border-l-2 border-primary/40 pl-4">
              <div className="font-mono font-bold text-2xl">{s.k}</div>
              <div className="text-xs text-slate-400 uppercase tracking-wider">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
